<medpace-editable-card
    title="Visit Details"
    mode="view"
    [showSwitchModeButton]="showSwitchModeButton"
    [showTitleAsteriskWhenEditMode]="true"
    [isLoading]="viewModel === null"
    [formGroup]="getFormGroup()"
    class="o-grid"
>
    @if (viewModel) {
        <medpace-editable-card-view-mode-content>
            <div class="o-grid">
                @if (viewModel.requestType === RequestTypes.PAYMENT && paymentRequest_Handler?.viewModel) {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site #</h5>
                                <span>{{ paymentRequest_Handler.viewModel.siteNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site Address</h5>
                                <span
                                    >{{ paymentRequest_Handler.viewModel.siteAddress.line1 }}&nbsp;{{
                                        paymentRequest_Handler.viewModel.siteAddress.line2
                                    }}&nbsp;{{ paymentRequest_Handler.viewModel.siteAddress.city }} ,&nbsp;{{
                                        paymentRequest_Handler.viewModel.siteAddress.stateOrProvince
                                    }}&nbsp;{{ paymentRequest_Handler.viewModel.siteAddress.postalCode }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Visit Name</h5>
                                <span>{{ paymentRequest_Handler.viewModel.visitName?.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Visit Date</h5>
                                <span>{{
                                    paymentRequest_Handler.viewModel.visitDate?.toDate() | dateFormat | uppercase
                                }}</span>
                            </div>
                        </div>
                    </div>
                }
                @if (viewModel.requestType === RequestTypes.TRAVEL && travelRequest_Handler?.viewModel) {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site #</h5>
                                <span>{{ travelRequest_Handler.viewModel.siteNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site Address</h5>
                                <span
                                    >{{ travelRequest_Handler.viewModel.siteAddress.line1 }}&nbsp;{{
                                        travelRequest_Handler.viewModel.siteAddress.line2
                                    }}&nbsp;{{ travelRequest_Handler.viewModel.siteAddress.city }} ,&nbsp;{{
                                        travelRequest_Handler.viewModel.siteAddress.stateOrProvince
                                    }}&nbsp;{{ travelRequest_Handler.viewModel.siteAddress.postalCode }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Additional Instructions to Find Address</h5>
                                <span>{{
                                    travelRequest_Handler.viewModel.specialNavigationInstructions || 'Unspecified'
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Visit Name</h5>
                                <span>{{ travelRequest_Handler.viewModel.visitName?.name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Visit Start Date</h5>
                                <span>{{
                                    travelRequest_Handler.viewModel.visitStartDateTime?.toDate()
                                        | dateFormat
                                        | uppercase
                                }}</span>
                            </div>
                        </div>
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Visit End Date</h5>
                                <span>{{
                                    travelRequest_Handler.viewModel.visitEndDateTime?.toDate() | dateFormat | uppercase
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Appointment Start Time</h5>
                                <span>{{
                                    travelRequest_Handler.viewModel.visitStartDateTime?.toDate()
                                        | dateFormat: DateFormat.timeOnly
                                }}</span>
                            </div>
                        </div>
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Appointment End Time</h5>
                                <span>{{
                                    travelRequest_Handler.viewModel.visitEndDateTime?.toDate()
                                        | dateFormat: DateFormat.timeOnly
                                }}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </medpace-editable-card-view-mode-content>
    }
    @if (viewModel) {
        <medpace-editable-card-edit-mode-content>
            <div class="o-grid">
                @if (viewModel.requestType === RequestTypes.PAYMENT && paymentRequest_Handler?.viewModel) {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site #</h5>
                                <span>{{ paymentRequest_Handler.viewModel.siteNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site Address</h5>
                                <span
                                    >{{ paymentRequest_Handler.viewModel.siteAddress.line1 }}&nbsp;{{
                                        paymentRequest_Handler.viewModel.siteAddress.line2
                                    }}&nbsp;{{ paymentRequest_Handler.viewModel.siteAddress.city }} ,&nbsp;{{
                                        paymentRequest_Handler.viewModel.siteAddress.stateOrProvince
                                    }}&nbsp;{{ paymentRequest_Handler.viewModel.siteAddress.postalCode }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__field">
                            @let visitNameOptions = visitNameOptions$ | async;
                            @if (visitNameOptions) {
                                <mds-dropdown
                                    [closeOnPageScroll]="false"
                                    appearance="outline"
                                    label="Visit Name"
                                    placeholder="Select visit"
                                    id="visitNameDropdown"
                                    data-cy="visitNameDropdown"
                                    [options]="visitNameOptions"
                                    [formCtrl]="paymentRequest_Handler.formGroup.controls.visitName"
                                    [required]="true"
                                    (selectionChange)="paymentRequest_Handler.onVisitNameChange($event)"
                                />
                            }
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__field">
                            <div class="c-datepicker">
                                <medpace-datepicker
                                    [formCtrl]="paymentRequest_Handler.formGroup.controls.visitDate"
                                    id="visitDate"
                                    data-cy="visitDateDatepicker"
                                    appearance="outline"
                                    label="Visit Date"
                                    [required]="true"
                                    (dateChange)="paymentRequest_Handler.onVisitDateChange($event)"
                                ></medpace-datepicker>
                            </div>
                        </div>
                    </div>
                }
                @if (viewModel.requestType === RequestTypes.TRAVEL && travelRequest_Handler?.viewModel) {
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site #</h5>
                                <span>{{ travelRequest_Handler.viewModel.siteNumber }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__item">
                            <div class="c-info__block">
                                <h5>Site Address</h5>
                                <span
                                    >{{ travelRequest_Handler.viewModel.siteAddress.line1 }}&nbsp;{{
                                        travelRequest_Handler.viewModel.siteAddress.line2
                                    }}&nbsp;{{ travelRequest_Handler.viewModel.siteAddress.city }} ,&nbsp;{{
                                        travelRequest_Handler.viewModel.siteAddress.stateOrProvince
                                    }}&nbsp;{{ travelRequest_Handler.viewModel.siteAddress.postalCode }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__field">
                            <mds-textarea
                                [formCtrl]="travelRequest_Handler.formGroup.controls.specialNavigationInstructions"
                                (input)="travelRequest_Handler.onSpecialNavigationInstructionsChange($event)"
                                id="specialNav"
                                [cdkAutosizeMinRows]="8"
                                [cdkAutosizeMaxRows]="8"
                                label="Additional Instructions to Find Address"
                                placeholder="Type here..."
                                appearance="outline"
                                [autoSize]="true"
                            ></mds-textarea>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__field">
                            @let visitNameOptions = visitNameOptions$ | async;
                            @if (visitNameOptions) {
                                <mds-dropdown
                                    [closeOnPageScroll]="false"
                                    appearance="outline"
                                    label="Visit Name"
                                    placeholder="Select visit"
                                    id="visitNameDropdown"
                                    data-cy="visitNameDropdown"
                                    [options]="visitNameOptions"
                                    [formCtrl]="travelRequest_Handler.formGroup.controls.visitName"
                                    [required]="true"
                                    (selectionChange)="travelRequest_Handler.onVisitNameChange($event)"
                                />
                            }
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__field half">
                            <medpace-datepicker
                                [formCtrl]="travelRequest_Handler.formGroup.controls.visitStartDate"
                                id="visitStartDate"
                                data-cy="visitStartDateDatepicker"
                                appearance="outline"
                                label="Visit Start Date"
                                [required]="true"
                                (dateChange)="travelRequest_Handler.onVisitStartDateChange($event)"
                            ></medpace-datepicker>
                        </div>
                        <div class="o-grid__field half">
                            <medpace-datepicker
                                [formCtrl]="travelRequest_Handler.formGroup.controls.visitEndDate"
                                id="visitEndDate"
                                data-cy="visitEndDateDatepicker"
                                appearance="outline"
                                label="Visit End Date"
                                [required]="true"
                                (dateChange)="travelRequest_Handler.onVisitEndDateChange($event)"
                            ></medpace-datepicker>
                        </div>
                    </div>
                    <div class="o-grid__row">
                        <div class="o-grid__field half">
                            <mds-dropdown
                                #startTime
                                [closeOnPageScroll]="false"
                                appearance="outline"
                                label="Appt. Start Time"
                                placeholder="Select time"
                                id="startDropdown"
                                [options]="timePickerOptions"
                                [formCtrl]="travelRequest_Handler.formGroup.controls.visitStartTime"
                                [required]="true"
                                (selectionChange)="travelRequest_Handler.onVisitStartTimeChange($event)"
                            ></mds-dropdown>
                        </div>
                        <div class="o-grid__field half">
                            <mds-dropdown
                                [closeOnPageScroll]="false"
                                [formCtrl]="travelRequest_Handler.formGroup.controls.visitEndTime"
                                appearance="outline"
                                label="Appt. End Time"
                                placeholder="Select time"
                                [options]="timePickerOptions"
                                id="endDropdown"
                                [required]="true"
                                (selectionChange)="travelRequest_Handler.onVisitEndTimeChange($event)"
                            ></mds-dropdown>
                        </div>
                    </div>
                }
            </div>
        </medpace-editable-card-edit-mode-content>
    }
</medpace-editable-card>
